import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule } from "@angular/core";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";

import { HttpClientModule } from "@angular/common/http";
import { IonicStorageModule } from "@ionic/storage";
import { AppVersion } from "@ionic-native/app-version";
import { Badge } from "@ionic-native/badge";

import { Device } from "@ionic-native/device";

import { FormsModule } from "@angular/forms";

import { FullCalendarModule } from "ng-fullcalendar";

import { MyApp } from "./app.component";
import { HomePage } from "../pages/home/home";
import { ListPage } from "../pages/list/list";
import { PerfilPage } from "../pages/perfil/perfil";
import { CuadrantePropioPage } from "../pages/cuadrante-propio/cuadrante-propio";
import { CuadranteCentroPage } from "../pages/cuadrante-centro/cuadrante-centro";
import { LicenciasPage } from "../pages/licencias/licencias";
import { MensajesPage } from "../pages/mensajes/mensajes";
import { SolicitudesPage } from "../pages/solicitudes/solicitudes";
import { SolicitudPage } from "../pages/solicitud/solicitud";
import { SolicitudnuevaPage } from "../pages/solicitudnueva/solicitudnueva";
import { NotificacionDetallePage } from "../pages/notificacion-detalle/notificacion-detalle";

import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";

import { GlobalProvider } from "../providers/global/global";
import { LoginProvider } from "../providers/login/login";
import { ConectorProvider } from "../providers/conector/conector";
import { Firebase } from "@ionic-native/firebase";

import { AngularFirestoreModule } from "@angular/fire/firestore";
import { AngularFireModule } from "@angular/fire";
import { PwaProvider } from "../providers/pwa/pwa";

import "firebase/messaging";
import { LoginPage } from "../pages/login/login";
import { LoginIosPage } from "../pages/login-ios/login-ios";
import { PwaIosProvider } from "../providers/pwa-ios/pwa-ios";
import { FirebaseProvider } from "../providers/firebase/firebase"; // only import firebase messaging or as needed;
import { ComunicacionesPage } from "../pages/comunicaciones/comunicaciones";
import { ComunicacionPage } from "../pages/comunicacion/comunicacion";
import { NuevaComunicacionPage } from "../pages/nueva-comunicacion/nueva-comunicacion";
import { DocumentosPage } from "../pages/documentos/documentos";
import { HorasPage } from "../pages/horas/horas";
import { OtrosPage } from "../pages/otros/otros";

const firebase = {
  apiKey: "AIzaSyBZ949UFlLo2q465lknTTOdtlTBLIVf2ZU",
  authDomain: "intraloeapp.firebaseapp.com",
  databaseURL: "https://intraloeapp.firebaseio.com",
  projectId: "intraloeapp",
  storageBucket: "intraloeapp.appspot.com",
  messagingSenderId: "365670655154",
  vapidKey:
    "BFpaaHQEuRmNoZ1-PnYQb9ZYC5yilNWO4-2sLE3utCUcB4mF73ANdUE2VOTDy9iQJMhVwMnAtpAdxn7dzLlLbi4",
};

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ListPage,
    PerfilPage,
    CuadrantePropioPage,
    CuadranteCentroPage,
    LicenciasPage,
    MensajesPage,
    SolicitudesPage,
    SolicitudPage,
    SolicitudnuevaPage,
    NotificacionDetallePage,
    LoginPage,
    LoginIosPage,
    ComunicacionesPage,
    ComunicacionPage,
    NuevaComunicacionPage,
    DocumentosPage,
    HorasPage,
    OtrosPage,
  ],
  imports: [
    AngularFireModule.initializeApp(firebase),
    AngularFirestoreModule,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    FullCalendarModule,
    IonicModule.forRoot(MyApp, {
      backButtonText: "",
      mode: "ios",
    }),
    IonicStorageModule.forRoot(),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    ListPage,
    PerfilPage,
    CuadrantePropioPage,
    CuadranteCentroPage,
    LicenciasPage,
    SolicitudesPage,
    SolicitudPage,
    SolicitudnuevaPage,
    MensajesPage,
    NotificacionDetallePage,
    LoginPage,
    LoginIosPage,
    ComunicacionesPage,
    ComunicacionPage,
    NuevaComunicacionPage,
    DocumentosPage,
    HorasPage,
    OtrosPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    GlobalProvider,
    LoginProvider,
    HttpClientModule,
    ConectorProvider,
    AppVersion,
    Device,
    Badge,
    Firebase,
    PwaProvider,
    PwaIosProvider,
    FirebaseProvider,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts